 $(document).ready(function(){
 /* Pre-Order Code 18-Oct-2024*/ 
   
   function onloaddata(){
      
      let flags = $('.variant-swatch input:checked').next('.variant-swatch__item').attr('varianttrue');
      let texts = $('.variant-swatch input:checked').next('.variant-swatch__item').attr('preordercopy');
     
      if(flags == "true"){
        setTimeout(function(){
            $('.product-form__add-button .loader-button__text').text('PRE-ORDER');
            $(".preordercopy").text(texts);
               $('.cstmlineItem').val('Yes');
          },10);
      }else{
         $('.product-form__add-button .loader-button__text').text('Add to cart');
         $(".preordercopy").text("");
         $('.cstmlineItem').val('');
      }
     
    }
    onloaddata();
   
    $(document).on('click', '.variant-swatch__item', function() {
      
        let texts = $(this).attr("preordercopy");
      
        if ($(this).attr('varianttrue') == 'true') {
          
          setTimeout(function(){
            $('.product-form__add-button .loader-button__text').text('PRE-ORDER');
            $(".preordercopy").text(texts);
            $('.cstmlineItem').val('Yes');
          },10);
        
        }else{
          
           $('.product-form__add-button .loader-button__text').text('Add to cart');
           $(".preordercopy").text("");
           $('.cstmlineItem').val('');
        }
    });

   
 /* Pre-Order Code 18-Oct-2024*/ 




 });


$(document).on('click','.cart-notification__view-cart ',function(){
   document.querySelector('a[aria-controls="mini-cart"]').click();
})